import React, { useState } from 'react';
import API_BASE from '../utils/apiBase';

const JobListingForm = ({ onJobAdded }) => {
  const [form, setForm] = useState({
    title: '',
    description: '',
    qualification: '',
    experience: '',
    positions: 1
  });
  const [status, setStatus] = useState('');

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setStatus('Saving...');
    const res = await fetch(`${API_BASE}/api/add_job.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(form)
    });
    const result = await res.json();
    setStatus(result.success ? 'Job added!' : 'Error: ' + result.error);
    if (result.success && onJobAdded) onJobAdded();
  };

  return (
    <form
      className="space-y-4 w-full max-w-lg mx-auto bg-black rounded-2xl shadow-xl p-8 border border-blue-100 mt-10"
      onSubmit={handleSubmit}
    >
      <h2 className="text-2xl font-bold text-blue-700 mb-4 text-center">Post a Job</h2>
      <div>
        <label className="block text-sm font-medium text-blue-900 mb-1">Title</label>
        <input
          name="title"
          placeholder="Title"
          value={form.title}
          onChange={handleChange}
          required
          className="w-full px-4 py-2 border border-blue-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 bg-blue-50"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-blue-900 mb-1">Description</label>
        <textarea
          name="description"
          placeholder="Description"
          value={form.description}
          onChange={handleChange}
          required
          className="w-full px-4 py-2 border border-blue-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 bg-blue-50 min-h-[80px]"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-blue-900 mb-1">Qualification</label>
        <input
          name="qualification"
          placeholder="Qualification"
          value={form.qualification}
          onChange={handleChange}
          className="w-full px-4 py-2 border border-blue-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 bg-blue-50"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-blue-900 mb-1">Experience</label>
        <input
          name="experience"
          placeholder="Experience"
          value={form.experience}
          onChange={handleChange}
          className="w-full px-4 py-2 border border-blue-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 bg-blue-50"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-blue-900 mb-1">Positions</label>
        <input
          name="positions"
          type="number"
          min="1"
          placeholder="Positions"
          value={form.positions}
          onChange={handleChange}
          required
          className="w-full px-4 py-2 border border-blue-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 bg-blue-50"
        />
      </div>
      <button
        type="submit"
        className="w-full py-2 px-4 bg-blue-700 hover:bg-blue-800 text-white font-semibold rounded-lg shadow transition"
      >
        Add Job
      </button>
      {status && (
        <div className="form-status text-center text-blue-700 font-medium mt-2">{status}</div>
      )}
    </form>
  );
};

export default JobListingForm;
